export const EXCLUDED_401_PATHS = [
  "/auth/login",
  "/auth/refresh",
  "/auth/logout",
  "/social-sdk/get-access-token"
];